import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      // 登录页
      path: '/',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/login/index')
    },
    {
      // 登录页
      path: '/login2',
      name: 'login2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/login/login2')
    },
    {
      // 客户单位登录页，2026-6 追加，用来和RCN门户网站对接
      path: '/login_for_customer',
      name: 'login_for_customer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/login/login_for_customer')
    },
    {
      // 首页
      path: '/home',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/home-page/index'),
      meta: {
        requireAuth: true
      },
      children: [
        // 用户管理选项
        {
          // 用户管理——>运营商管理
          path: 'operator/:func/:id',
          name: 'operator',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/operator/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>服务商管理
          path: 'serviceprovider/:func/:id',
          name: 'serviceprovider',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/service-provider/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>服务部门管理
          path: 'servicedepartment/:func/:id',
          name: 'servicedepartment',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/service-department/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>维护人员管理
          path: 'maintenancepersonnel/:func/:id',
          name: 'maintenancepersonnel',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/maintenance-personnel/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>网络店
          path: 'secondaryagent/:func/:id',
          name: 'secondaryagent',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/secondary-agent/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>客户单位管理
          path: 'customerunit/:func/:id',
          name: 'customerunit',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/customer-unit/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 用户管理——>客户分点管理
          path: 'customerpoints/:func/:id',
          name: 'customerpoints',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/user-management/customer-points/index'),
          meta: {
            requireAuth: true
          }
        },
        // 其他设定选项
        {
          // 其他设定——>机型设定
          path: 'modelsettings/:func/:id',
          name: 'modelsettings',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/model-settings/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 其他设定——>品牌设定
          path: 'brandsetup/:func/:id',
          name: 'brandsetup',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/brand-setting/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 其他设定——>通知设定
          path: 'notificationsettings',
          name: 'notificationsettings',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/notification-settings/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 其他设定——>本地服务器管理
          path: 'Localserver',
          name: 'Localserver',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/local-server/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 其他设定——>模板设定
          path: 'defaultSettings',
          name: 'defaultSettings',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/default-settings/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 其他设定——>使用手册管理
          path: 'manualmanagement',
          name: 'manualmanagement',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/other-settings/manual-management/index'),
          meta: {
            requireAuth: true
          }
        },
        // 报表导出模块
        {
          // 报表导出——>每日印量
          path: 'dailyyield',
          name: 'dailyyield',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/report-export/daily-yield/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 报表导出——>每月印量
          path: 'monthlyyield',
          name: 'monthlyyield',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/report-export/monthly-yield/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          // 报表导出——>印量统计
          path: 'printvolumestatistics',
          name: 'printvolumestatistics',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/report-export/print-volume-statistics/index'),
          meta: {
            requireAuth: true
          }
        },
        // 合同管理
        {
          path: 'contract/:func/:id',
          name: 'contract',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/contract-administration/index'),
          meta: {
            requireAuth: true
          }
        },
        // 设备管理
        {
          path: 'device/:func/:id',
          name: 'device',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '@/views/device-management/index'),
          meta: {
            requireAuth: true
          }
        },
        // 设备详情
        {
          path: 'devicedetails/:func/:id',
          name: 'devicedetails',
          component: () => import(/* webpackChunkName: "about" */ '@/views/device-management/device-details'),
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      // 重置密码成功
      path: '/passwordsuccess',
      name: 'passwordsuccess',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/reset/success')
    },
    {
      // 重置密码失败
      path: '/passwordfail',
      name: 'passwordfail',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/reset/fail')
    },
    {
      // 激活成功
      path: '/activatesuccess',
      name: 'activatesuccess',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/activate/success')
    },
    {
      // 激活失败
      path: '/activatefail',
      name: 'activatefail',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/activate/fail')
    },
    {
      // 重置密码页
      path: '/accountResetPassword',
      name: 'Password',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/reset/index')
    },
    {
      // 激活页面
      path: '/accountRegistCompletion',
      name: 'activate',
      component: () => import(/* webpackChunkName: "about" */ '@/views/password-settings/activate/index')
    },
    {
      // 用户协议
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "about" */ '@/views/user-agreement/index')
    },
    {
      // 普印通扫隐私协议
      path: '/universal-scan-privacy-policy',
      name: 'universal-scan-privacy-policy',
      component: () => import(/* webpackChunkName: "about" */ '@/views/z-universalscanapp/privacy-policy')
    },
    {
      // 404路由匹配
      path: '*',
      name: '404',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/404/404')
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
